<bc-footer
  [bottomTextLeftContent]="[
    'Copyright © ' + this.year + ' Grupo Bancolombia.',
  ]"
>
</bc-footer>
